import { render, staticRenderFns } from "./HxeChangguanDdtcBlock.vue?vue&type=template&id=e2e93abc&scoped=true"
import script from "./HxeChangguanDdtcBlock.vue?vue&type=script&lang=js"
export * from "./HxeChangguanDdtcBlock.vue?vue&type=script&lang=js"
import style0 from "./HxeChangguanDdtcBlock.vue?vue&type=style&index=0&id=e2e93abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e93abc",
  null
  
)

export default component.exports